<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import UPDATE from '@/components/page/update.vue'
  import FORM from '@/components/page/form.vue'
  import Url from '@/views/crs/util/url'
  import Qs from 'qs'
  const os = {"IOS":"IOS","Android":"Android"};
  export default {
    name: 'activechannel',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            this.dataChanage(Url.active.channel.del,{id:row.id},res =>{
                if (res.code == 0){
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if(window.$t('crs.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        const url = model.id?Url.active.channel.edit:Url.active.channel.save;
        this.dataChanage(url,model,res =>{
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                { title: 'id', field: 'id',hidden:true},
                { title: window.$t('crs.active.name'), field: 'name'},
                { title: window.$t('crs.active.pkg'), field: 'pkg'},
                { title: window.$t('crs.active.os'), field: 'os',type:2,optionList:os},
            ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs.active.name'), field: 'name'},
              { title: window.$t('crs.active.pkg'), field: 'pkg'},
              { title: window.$t('crs.active.os'), field: 'os'},
              { title: window.$t('crs.common.remark'), field: 'remark'},
              { click: window.$t('crs.bt.search')},
              { click: window.$t('crs.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.channel.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('crs.active.name'), field: 'name'},
              { title: window.$t('crs.active.pkg'), field: 'pkg'},
              { title: window.$t('crs.active.os'), field: 'os'},
              { title: window.$t('crs.common.remark'), field: 'remark'},
              { title: window.$t('crs.common.createTime'), field: 'createTime'},
              { title: window.$t('crs.bt.operation'),btnClick:[{name:window.$t('crs.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('crs.bt.delete'),click:"delete",type:"primary",icon: "el-icon-delete"}]},
          ]
        }
      }
    }
  }
</script>
